import { render, staticRenderFns } from "./ThreeaseTicketIcon.vue?vue&type=template&id=7dd338d2&"
import script from "./ThreeaseTicketIcon.vue?vue&type=script&lang=ts&"
export * from "./ThreeaseTicketIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports